export const ARTIFACT_FILE_TYPES = {
  IMAGE: 'image',
  JSON: 'json',
  TEXT: 'text',
  CODE: 'code',
  MARKDOWN: 'markdown',
  MODEL: 'model',
  DIRECTORY: 'directory',
  UNSUPPORTED: 'unsupported',
} as const;

export type ArtifactFileType = (typeof ARTIFACT_FILE_TYPES)[keyof typeof ARTIFACT_FILE_TYPES];
